import { Link } from "react-router-dom"
import styled from "styled-components"

export default function Abuse() {
  return (
    <Page>
      <Link to="/">pepchat</Link>
      <h1>Report abuse</h1>
      <p>Contact support about an account, message or other content on pepchat.</p>
      <p>Include the username or content link, what happened and when. Share only the details needed to explain your concern.</p>
      <a href="mailto:jashwanthbj9@gmail.com?subject=pepchat%20abuse%20report">Email support</a>
      <p>You can also use our <Link to="/#contact">contact form</Link>.</p>
      <Link to="/privacy">Privacy policy</Link>
    </Page>
  )
}

const Page = styled.main`
  width: min(100%, 760px); padding: 64px 24px; min-height: 100vh;
  color: #eee; background: #080808; line-height: 1.8;
  h1 { font-size: 36px; line-height: 1.2; margin-top: 48px; }
  p { color: #bbb; } a { color: #fff; text-underline-offset: 4px; }
  a:focus-visible { outline: 2px solid #aaa; outline-offset: 4px; }
`
